import { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../../utils/constant";

const MAX_DIGITS = 9;

const CustomSubscriptionModal = ({ show, onHide, adminId }) => {
  const [employeeLimit, setEmployeeLimit] = useState("");
  const [smsLimit, setSmsLimit] = useState("");

  const [perUserCost, setPerUserCost] = useState("");
  const [perSmsCost, setPerSmsCost] = useState("");

  const [baseCharges, setBaseCharges] = useState("");
  const [billingCycle, setBillingCycle] = useState("yearly");

  const [totalCost, setTotalCost] = useState(0);

  const handleNumberInput = (value, setter) => {
    let cleaned = value.replace(/[^0-9.]/g, "");

    const parts = cleaned.split(".");

    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts[1];
    }

    if (parts[0].length > MAX_DIGITS) {
      parts[0] = parts[0].slice(0, MAX_DIGITS);
      cleaned = parts.join(".");
    }
    if (parts[1]?.length > 2) {
      cleaned = parts[0] + "." + parts[1].slice(0, 2);
    }

    setter(cleaned);
  };
  useEffect(() => {
    const users = Number(employeeLimit) || 0;
    const sms = Number(smsLimit) || 0;
    const userCost = Number(perUserCost) || 0;
    const smsCost = Number(perSmsCost) || 0;
    const base = Number(baseCharges) || 0;

    let total = base + users * userCost + sms * smsCost;

    if (total > 999999999999) {
      total = 999999999999;
    }

    setTotalCost(Number(total.toFixed(2)));
  }, [employeeLimit, smsLimit, perUserCost, perSmsCost, baseCharges]);

  const handleSubmit = async () => {
    if (
      !employeeLimit ||
      !smsLimit ||
      !perUserCost ||
      !perSmsCost ||
      !baseCharges
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const payload = {
        admin_user: adminId,
        user_limit: Number(employeeLimit),
        sms_limit: Number(smsLimit),
        billingCycle,
        baseCharges: Number(baseCharges),
        totalCost: Number(totalCost),
      };

      await axios.post(
        `${BASE_URL}/users/subscriptions/custom-subscription/`,
        payload,
        { headers: HEADERS },
      );

      toast.success("Custom subscription sent successfully");
      onHide();
    } catch (error) {
      const message =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Something went wrong";

      toast.error(message);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Custom Subscription Plan</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Billing Cycle *</Form.Label>
            <Form.Select
              value={billingCycle}
              onChange={(e) => setBillingCycle(e.target.value)}
            >
              <option value="yearly">Yearly</option>
            </Form.Select>
          </Col>

          <Col md={4}>
            <Form.Label>Base Charges (₹) *</Form.Label>
            <Form.Control
              type="text"
              value={baseCharges}
              onChange={(e) =>
                handleNumberInput(e.target.value, setBaseCharges)
              }
              placeholder="Enter base charges"
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={3}>
            <Form.Label>Total Users *</Form.Label>
            <Form.Control
              type="text"
              value={employeeLimit}
              onChange={(e) =>
                handleNumberInput(e.target.value, setEmployeeLimit)
              }
              placeholder="Enter users"
            />
          </Col>

          <Col md={3}>
            <Form.Label>Cost / User (₹) *</Form.Label>
            <Form.Control
              type="text"
              value={perUserCost}
              onChange={(e) =>
                handleNumberInput(e.target.value, setPerUserCost)
              }
              placeholder="Enter cost"
            />
          </Col>

          <Col md={3}>
            <Form.Label>Total SMS *</Form.Label>
            <Form.Control
              type="text"
              value={smsLimit}
              onChange={(e) => handleNumberInput(e.target.value, setSmsLimit)}
              placeholder="Enter SMS"
            />
          </Col>

          <Col md={3}>
            <Form.Label>Cost / SMS (₹) *</Form.Label>
            <Form.Control
              type="text"
              value={perSmsCost}
              onChange={(e) => handleNumberInput(e.target.value, setPerSmsCost)}
              placeholder="Enter SMS cost"
            />
          </Col>
        </Row>

        <div className="bg-light rounded p-3 text-center fw-bold fs-5">
          Total Cost: ₹{totalCost.toLocaleString()}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSubmit}>
          Raise Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomSubscriptionModal;
